<template>
    <div>
        Stripe Return
    </div>
</template>

<script>
export default {
    name: "StripeReturn",
    head: {
        title: 'Stripe | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Description'
            }
        ],
    },
}
</script>
